/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Loader} from 'react-overlay-loader';
import {Redirect} from 'react-router-dom';
import xosphereLogo from '../../assets/images/xosphere-logo.png';
import * as actions from '../../store/actions';
import Error from "../../components/UI/Error";
import PasswordStrengthBar from 'react-password-strength-bar';

class NewPassword extends Component {
    state = {
        guid: '',
        password: '',
        showPassword: false
    };

    componentWillMount() {
        const params = new URLSearchParams(this.props.location.search);
        const guid = params.get('guid');
        this.setState({guid: guid});
    }

    handlePasswordChange = (event) => {
        this.setState({password: event.target.value.trim()})
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.onNewPassword(this.state.guid, this.state.password);
        this.setState({showPassword: false});
    };

    togglePassword = (event) => {
        event.preventDefault();
        let showPw = this.state.showPassword;
        this.setState({showPassword: !showPw});
    };

    handleKeyPress = (event) => {
        if(event.key === 'Enter') {
            event.preventDefault();
            this.props.onNewPassword(this.state.guid, this.state.password);
        }
    };

    render() {
        let redirect = null;
        if (this.props.redirect) {
            redirect = <Redirect to="/"/>
        }
        let passwordInput = null;
        if (this.state.showPassword) {
            passwordInput = <input type="text" className="form-control" autocomplete="new-password" maxLength="128" placeholder="Password" value={this.state.password} onChange={this.handlePasswordChange} onKeyPress={e => this.handleKeyPress(e)}/>
        } else {
            passwordInput = <input type="password" className="form-control" autocomplete="new-password" maxLength="128" placeholder="Password" value={this.state.password} onChange={this.handlePasswordChange} onKeyPress={e => this.handleKeyPress(e)}/>
        }

        return (
            <div className="container-fluid">
                {redirect}
                <Loader fullPage={true} loading={this.props.loading}/>
                <div className="row justify-content-md-center">
                    <div className="col-lg-10 col-md-12 text-center">
                        <div className="row justify-content-sm-center login-top">
                            <div className="col-lg-4 col-md-5 col-sm-7 text-center"><img
                                src={xosphereLogo}
                                alt="" title=""
                                className="mb-4"/>
                                <Error errorMsg={this.props.error} divClass="col-lg-5 col-sm-6 col-center"/>
                                <div className="form-group row no-gutters mb-4">
                                    <div className="col-11">
                                        {passwordInput}
                                        <PasswordStrengthBar password={this.state.password} />
                                    </div>
                                    <div className="col-1">
                                        <div className="mt-2"><a href="#" className="gray" onClick={this.togglePassword}><i className="fa fa-eye"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group mb-5">
                                    <input type="submit" value="Set Password" className="btn btn-primary" onClick={this.handleSubmit}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

const mapStateToProps = state => {
    return {
        loading: state.newPassword.loading,
        error: state.newPassword.error,
        redirect: state.newPassword.redirect
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onNewPassword: (guid, password) => dispatch(actions.newPassword(guid, password))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPassword)